// Profile tabs are addressable URLs (/profile, /profile/views) rather than a
// `?page=` query param. The router and the tab bar both resolve through this
// map, so a tab can't exist in one and be missing from the other.
export const PROFILE_TAB_PATHS = {
  profile: '/profile',
  profile_views: '/profile/views',
};

// Unknown or missing tabs fall back to the profile tab — this is what turns a
// legacy `?page=whatever` link into a valid destination instead of a dead one.
export const profileTabPath = (tab) =>
  PROFILE_TAB_PATHS[tab] || PROFILE_TAB_PATHS.profile;

// Reverse of `profileTabPath`: which tab a path is showing. Trailing slashes are
// tolerated so `/profile/views/` resolves like `/profile/views`.
export const profileTabFromPath = (pathname = '') =>
  pathname.replace(/\/+$/, '') === PROFILE_TAB_PATHS.profile_views
    ? 'profile_views'
    : 'profile';
